import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { DisputesPage } from "@/features/disputes";

export const Route = createFileRoute("/disputes/")({
  component: DisputesRoute,
});

function DisputesRoute() {
  return (
    <AdminDashboardShell>
      <DisputesPage />
    </AdminDashboardShell>
  );
}
